import React, { FC } from 'react';
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';
import ContextConfig from './ContextConfig';
import AgentContextConfig from './AgentContextConfig';
import CompanyContextConfig from './CompanyContextConfig';
import BuyerContextConfig from './BuyerContextConfig';
import { Top } from 'ui/pages/Top/Top';
import { AboutMany } from 'ui/pages/Top/AboutMany';
import { AboutService } from 'ui/pages/Top/AboutService';
import { NotFound } from 'ui/pages/NotFound/NotFound';
import { CompanyProfile } from 'ui/pages/CompanyProfile/CompanyProfile';
import { TermsOfService } from 'ui/pages/TermsOfService/TermsOfService';
import { TermsOfServiceForSupporter } from 'ui/pages/TermsOfServiceForSupporter/TermsOfServiceForSupporter';
import { PrivacyPolicy } from 'ui/pages/PrivacyPolicy/PrivacyPolicy';
import { ValuationEstimate } from 'ui/pages/ValuationEstimate/ValuationEstimate';
import { TopForAgent } from 'ui/pages/TopForAgent/TopForAgent';
import { TopForBuyer } from 'ui/pages/TopForBuyer/TopForBuyer';
import { Contact } from 'ui/pages/Contact/Contact';
import { SendRegistrationMail } from 'ui/pages/SendRegistrationMail/SendRegistrationMail';
import { SentRegistrationMail } from 'ui/pages/SendRegistrationMail/SentRegistrationMail';
import { CompanyUserRegistrationAuth } from 'ui/pages/CompanyUserRegistrationAuth/CompanyUserRegistrationAuth';
import { PasswordRegistration } from 'ui/pages/Company/PasswordRegistration/PasswordRegistration';
import { CompanyProfileRegistration } from 'ui/pages/Company/CompanyProfileRegistration/CompanyProfileRegistration';
import { CompanyAddCompany } from 'ui/pages/Company/CompanyAddCompany/CompanyAddCompany';
import { CompanyUserProfileRegistration } from 'ui/pages/Company/CompanyUserProfileRegistration/CompanyUserProfileRegistration';
import { CompanyUserPasswordReset } from 'ui/pages/Company/CompanyUserPasswordReset/CompanyUserPasswordReset';
import { CompanyDashboard } from 'ui/pages/Company/CompanyDashboard/CompanyDashboard';
import { CompanyApplication } from 'ui/pages/Company/CompanyApplication/CompanyApplication';
import { CompanyStandard } from 'ui/components/layouts/CompanyStandard/CompanyStandard';
import { CompanyLogin } from 'ui/pages/Company/CompanyLogin/CompanyLogin';
import { CompanyChatRoom } from 'ui/pages/Company/CompanyChatRoom/CompanyChatRoom';
import { CompanyMatchList } from 'ui/pages/Company/CompanyMatchList/CompanyMatchList';
import { CompanyBilling } from 'ui/pages/Company/CompanyBilling/CompanyBilling';
import { CompanyMemberList } from 'ui/pages/Company/CompanyMemberList/CompanyMemberList';
import { CompanyMemberEdit } from 'ui/pages/Company/CompanyMemberList/CompanyMemberEdit';
import { CompanySurveyForm } from 'ui/pages/Company/CompanySurvey/CompanySurveyForm';
import { CompanyEdit } from 'ui/pages/Company/CompanyEdit/CompanyEdit';
import { CompanyAgentProfile } from 'ui/pages/Company/CompanyAgentProfile/CompanyAgentProfile';
import { CompanySupportChat } from 'ui/pages/Company/SupportChat/CompanySupportChat';

import { AgentUserRegistrationAuth } from 'ui/pages/Agent/AgentUserRegistrationAuth/AgentUserRegistrationAuth';
import { AgentPasswordRegistration } from 'ui/pages/Agent/AgentPasswordRegistration/AgentPasswordRegistration';
import { AgentUserPasswordReset } from 'ui/pages/Agent/AgentUserPasswordReset/AgentUserPasswordReset';
import { AgentLogin } from 'ui/pages/Agent/AgentLogin/AgentLogin';
import { AgentProfileRegistration } from 'ui/pages/Agent/AgentProfileRegistration/AgentProfileRegistration';
import { AgentUserProfileRegistration } from 'ui/pages/Agent/AgentUserProfileRegistration/AgentUserProfileRegistration';
import { AgentStandard } from 'ui/components/layouts/AgentStandard/AgentStandard';
import { AgentDashboard } from 'ui/pages/Agent/AgentDashboard/AgentDashboard';
import { AgentCompanyList } from 'ui/pages/Agent/AgentCompanyList/AgentCompanyList';
import { AgentBuyerList } from 'ui/pages/Agent/AgentBuyerList/AgentBuyerList';
import { BuyerDetail } from 'ui/pages/Agent/BuyerDetail/BuyerDetail';
import { CompanyDetail } from 'ui/pages/Agent/CompanyDetail/CompanyDetail';
import { CompanyDetailAfterMatch } from 'ui/pages/Agent/CompanyDetailAfterMatch/CompanyDetailAfterMatch';
import { BuyerDetailAfterMatch } from 'ui/pages/Agent/BuyerDetailAfterMatch/BuyerDetailAfterMatch';
import { AgentChatRoom } from 'ui/pages/Agent/AgentChatRoom/AgentChatRoom';
import { AgentMatchList } from 'ui/pages/Agent/AgentMatchList/AgentMatchList';
import { AgentOfferList } from 'ui/pages/Agent/AgentOfferList/AgentOfferList';
import { AgentBilling } from 'ui/pages/Agent/AgentBilling/AgentBilling';
import { AgentMemberList } from 'ui/pages/Agent/AgentMemberList/AgentMemberList';
import { AgentMemberEdit } from 'ui/pages/Agent/AgentMemberList/AgentMemberEdit';
import { AgentSurveyForm } from 'ui/pages/Agent/AgentSurvey/AgentSurveyForm';
import { AgentEdit } from 'ui/pages/Agent/AgentEdit/AgentEdit';

import { BuyerUserRegistrationAuth } from 'ui/pages/Buyer/BuyerUserRegistrationAuth/BuyerUserRegistrationAuth';
import { BuyerPasswordRegistration } from 'ui/pages/Buyer/BuyerPasswordRegistration/BuyerPasswordRegistration';
import { BuyerLogin } from 'ui/pages/Buyer/BuyerLogin/BuyerLogin';
import { BuyerProfileRegistration } from 'ui/pages/Buyer/BuyerProfileRegistration/BuyerProfileRegistration';
import { SendRegistrationMailForBuyer } from 'ui/pages/Buyer/SendRegistrationMailForBuyer/SendRegistrationMailForBuyer';
import { SentRegistrationMailForBuyer } from 'ui/pages/Buyer/SendRegistrationMailForBuyer/SentRegistrationMailForBuyer';
import { BuyerUserPasswordReset } from 'ui/pages/Buyer/BuyerUserPasswordReset/BuyerUserPasswordReset';
import { BuyerStandard } from 'ui/components/layouts/BuyerStandard/BuyerStandard';
import { BuyerDashboard } from 'ui/pages/Buyer/BuyerDashboard/BuyerDashboard';
import { BuyerApplication } from 'ui/pages/Buyer/BuyerApplication/BuyerApplication';
import { BuyerUserProfileRegistration } from 'ui/pages/Buyer/BuyerUserProfileRegistration/BuyerUserProfileRegistration';
import { BuyerChatRoom } from 'ui/pages/Buyer/BuyerChatRoom/BuyerChatRoom';
import { BuyerMatchList } from 'ui/pages/Buyer/BuyerMatchList/BuyerMatchList';
import { BuyerBilling } from 'ui/pages/Buyer/BuyerBilling/BuyerBilling';
import { BuyerMemberList } from 'ui/pages/Buyer/BuyerMemberList/BuyerMemberList';
import { BuyerMemberEdit } from 'ui/pages/Buyer/BuyerMemberList/BuyerMemberEdit';
import { BuyerSurveyForm } from 'ui/pages/Buyer/BuyerSurvey/BuyerSurveyForm';
import { BuyerEdit } from 'ui/pages/Buyer/BuyerEdit/BuyerEdit';
import { BuyerAgentProfile } from 'ui/pages/Buyer/BuyerAgentProfile/BuyerAgentProfile';
import { BuyerSupportChat } from 'ui/pages/Buyer/SupportChat/BuyerSupportChat';

import SupporterContextConfig from './SupporterContextConfig';
import { SupportUserRegistrationAuth } from 'ui/pages/Supporter/SupportUserRegistrationAuth/SupportUserRegistrationAuth';
import { SupportUserRegistrationPassword } from 'ui/pages/Supporter/SupportUserRegistrationPassword/SupportUserRegistrationPassword';
import { SupportUserProfileRegistration } from 'ui/pages/Supporter/SupportUserProfileRegistration/SupportUserProfileRegistration';
import { SupportUserDashboard } from 'ui/pages/Supporter/SupportUserDashboard/SupportUserDashboard';
import { SupporterCompanyEdit } from 'ui/pages/Supporter/CompanyEdit/SupporterCompanyEdit';
import { SupporterBuyerEdit } from 'ui/pages/Supporter/BuyerEdit/SupporterBuyerEdit';
import { SupporterChatRoomList } from 'ui/components/supporter/patterns/ChatRoom/SupporterChatRoomList';
import { SupportStandard } from 'ui/components/layouts/SupportStandard/SupportStandard';
import { SupportLogin } from 'ui/pages/Supporter/SupportLogin/SupportLogin';
import { SupportUserPasswordReset } from 'ui/pages/Supporter/SupportUserPasswordReset/SupportUserPasswordReset';
import { SupporterTransferList } from 'ui/pages/Supporter/SupporterTransferList/SupporterTransferList';

const router = createBrowserRouter([
    {
        element: <ContextConfig />,
        children: [
            { path: '/', element: <Top /> },
            { path: '/about_many/', element: <AboutMany /> },
            { path: '/about_service/', element: <AboutService /> },
            { path: '/agent/', element: <TopForAgent /> },
            { path: '/buyer/', element: <TopForBuyer /> },
            { path: '/contact/', element: <Contact /> },
            { path: '/company_profile/', element: <CompanyProfile /> },
            { path: '/terms/', element: <TermsOfService /> },
            { path: '/terms/supporter/', element: <TermsOfServiceForSupporter /> },
            { path: '/privacy/', element: <PrivacyPolicy /> },

            { path: '/valuation/estimate/', element: <ValuationEstimate /> },
            { path: '/send-registration-mail/', element: <SendRegistrationMail /> },
            { path: '/send-registration-mail/complete/', element: <SentRegistrationMail /> },

            { path: '/buyer/send-registration-mail/', element: <SendRegistrationMailForBuyer /> },
            { path: '/buyer/send-registration-mail/complete/', element: <SentRegistrationMailForBuyer /> },
        ],
    },

    {
        // 売り手企業
        element: <CompanyContextConfig />,
        children: [
            { path: '/company_user_registration_auth/:url_id/', element: <CompanyUserRegistrationAuth /> },
            { path: '/company_user_registration_auth/from_invite/:url_id/', element: <CompanyUserRegistrationAuth /> },
            { path: '/company/registration/password/:url_id/', element: <PasswordRegistration /> },
            { path: '/company/registration/password/from_invite/:url_id/', element: <PasswordRegistration /> },
            { path: '/company/login/', element: <CompanyLogin /> },
            { path: '/company/registration/company_profile/', element: <CompanyProfileRegistration /> },
            { path: '/company/password-reset/', element: <CompanyUserPasswordReset /> },

            {
                element: <CompanyStandard />,
                children: [
                    { path: '/company/dashboard/', element: <CompanyDashboard /> },
                    { path: '/company/add_company/', element: <CompanyAddCompany /> },
                    { path: '/company/profile/application/', element: <CompanyApplication /> },
                    { path: '/company/registration/user_profile/', element: <CompanyUserProfileRegistration /> },
                    { path: '/company/message/:chat_room_id?', element: <CompanyChatRoom /> },
                    { path: '/company/match/', element: <CompanyMatchList /> },
                    { path: '/company/billing/', element: <CompanyBilling /> },
                    { path: '/company/member/', element: <CompanyMemberList /> },
                    { path: '/company/member/edit/:user_id', element: <CompanyMemberEdit /> },
                    {
                        path: '/company/survey/form/:matchId/',
                        element: <CompanySurveyForm />,
                    },
                    { path: '/company/edit/', element: <CompanyEdit /> },
                    { path: '/company/agent_profile/:agentId/', element: <CompanyAgentProfile /> },
                    { path: '/company/support_chat/', element: <CompanySupportChat /> },
                ],
            },
        ],
    },

    {
        // 仲介企業
        element: <AgentContextConfig />,
        children: [
            { path: '/agent_user_registration_auth/:url_id/', element: <AgentUserRegistrationAuth /> },
            { path: '/agent_user_registration_auth/from_invite/:url_id/', element: <AgentUserRegistrationAuth /> },
            { path: '/agent/registration/password/:url_id/', element: <AgentPasswordRegistration /> },
            { path: '/agent/registration/password/from_invite/:url_id/', element: <AgentPasswordRegistration /> },
            { path: '/agent/password-reset/', element: <AgentUserPasswordReset /> },
            { path: '/agent/login/', element: <AgentLogin /> },
            {
                element: <AgentStandard />,
                children: [
                    { path: '/agent/registration/agent_profile/', element: <AgentProfileRegistration /> },
                    { path: '/agent/registration/user_profile/', element: <AgentUserProfileRegistration /> },
                    { path: '/agent/dashboard/', element: <AgentDashboard /> },
                    { path: '/agent/company/list/', element: <AgentCompanyList /> },
                    { path: '/agent/companies/:company_id', element: <CompanyDetail /> },
                    { path: '/agent/buyer/list/', element: <AgentBuyerList /> },
                    { path: '/agent/buyers/:buyer_id', element: <BuyerDetail /> },
                    { path: '/agent/companies/after_match/:company_id', element: <CompanyDetailAfterMatch /> },
                    { path: '/agent/buyers/after_match/:buyer_id', element: <BuyerDetailAfterMatch /> },
                    { path: '/agent/message/:chat_room_id?', element: <AgentChatRoom /> },
                    { path: '/agent/offer/', element: <AgentOfferList /> },
                    { path: '/agent/match/', element: <AgentMatchList /> },
                    { path: '/agent/billing/', element: <AgentBilling /> },
                    { path: '/agent/member/', element: <AgentMemberList /> },
                    { path: '/agent/member/edit/:user_id', element: <AgentMemberEdit /> },
                    {
                        path: '/agent/survey/form/:matchId/',
                        element: <AgentSurveyForm />,
                    },
                    { path: '/agent/edit/', element: <AgentEdit /> },
                ],
            },
        ],
    },

    {
        // 買い手企業
        element: <BuyerContextConfig />,
        children: [
            { path: '/buyer_user_registration_auth/:url_id/', element: <BuyerUserRegistrationAuth /> },
            { path: '/buyer_user_registration_auth/from_invite/:url_id/', element: <BuyerUserRegistrationAuth /> },
            { path: '/buyer/registration/password/:url_id/', element: <BuyerPasswordRegistration /> },
            { path: '/buyer/registration/password/from_invite/:url_id/', element: <BuyerPasswordRegistration /> },
            { path: '/buyer/login/', element: <BuyerLogin /> },
            { path: '/buyer/registration/company_profile/', element: <BuyerProfileRegistration /> },
            { path: '/buyer/password-reset/', element: <BuyerUserPasswordReset /> },
            {
                element: <BuyerStandard />,
                children: [
                    { path: '/buyer/dashboard/', element: <BuyerDashboard /> },
                    { path: '/buyer/profile/application/', element: <BuyerApplication /> },
                    { path: '/buyer/registration/user_profile/', element: <BuyerUserProfileRegistration /> },
                    { path: '/buyer/message/:chat_room_id?', element: <BuyerChatRoom /> },
                    { path: '/buyer/match/', element: <BuyerMatchList /> },
                    { path: '/buyer/billing/', element: <BuyerBilling /> },
                    { path: '/buyer/member/', element: <BuyerMemberList /> },
                    { path: '/buyer/member/edit/:user_id', element: <BuyerMemberEdit /> },
                    {
                        path: '/buyer/survey/form/:matchId/',
                        element: <BuyerSurveyForm />,
                    },
                    { path: '/buyer/edit/', element: <BuyerEdit /> },
                    { path: '/buyer/agent_profile/:agentId/', element: <BuyerAgentProfile /> },
                    { path: '/buyer/support_chat/', element: <BuyerSupportChat /> },
                ],
            },
        ],
    },

    {
        // サポーター
        element: <SupporterContextConfig />,
        children: [
            { path: '/supporter_user_registration_auth/:url_id/', element: <SupportUserRegistrationAuth /> },
            { path: '/supporter/registration/password/:url_id/', element: <SupportUserRegistrationPassword /> },
            { path: '/supporter/registration/user_profile/', element: <SupportUserProfileRegistration /> },
            { path: '/supporter/login/', element: <SupportLogin /> },
            { path: '/supporter/password-reset/', element: <SupportUserPasswordReset /> },
            {
                element: <SupportStandard />,
                children: [
                    { path: '/supporter/dashboard/', element: <SupportUserDashboard /> },
                    { path: '/supporter/company/edit/:type/:companyId', element: <SupporterCompanyEdit /> },
                    { path: '/supporter/buyer/edit/:type/:buyerId', element: <SupporterBuyerEdit /> },
                    { path: '/supporter/message/:chat_room_id?', element: <SupporterChatRoomList /> },
                    { path: '/supporter/transfer/', element: <SupporterTransferList /> },
                ],
            },
        ],
    },

    { path: '*', element: <Navigate to="/not_found/" replace /> },
    { path: '/not_found/', element: <NotFound /> },
]);

const RouterConfig: FC = () => <RouterProvider router={router} />;

export default RouterConfig;
